module.exports = __webpack_public_path__ + "img/300x600_layout_1.daace143.svg";